module.exports = __webpack_public_path__ + "img/albertoPng.3d3b9a33.png";